import { Recipe } from '../../api/Recipe';

export const updateFavoritePendingIds = (
  recipeId: string,
  isPending: boolean,
  previousIds: string[]
): string[] => {
  if (isPending) {
    return previousIds.includes(recipeId) ? previousIds : [...previousIds, recipeId];
  }

  return previousIds.filter((id) => id !== recipeId);
};

const setRecipePendingState = (
  recipeId: string,
  isPending: boolean,
  setFavoritePendingIds: React.Dispatch<React.SetStateAction<string[]>>
) => {
  setFavoritePendingIds((previousIds) =>
    updateFavoritePendingIds(recipeId, isPending, previousIds)
  );
};

const rollbackFavoriteMutation = (
  previousFavorites: Recipe[],
  setCachedFavorites: (favorites: Recipe[]) => void
) => {
  setCachedFavorites(previousFavorites);
};

interface ExecuteOptimisticFavoriteMutationOptions {
  recipeId: string;
  nextFavorites: Recipe[];
  previousFavorites: Recipe[];
  setCachedFavorites: (favorites: Recipe[]) => void;
  setFavoritePendingIds: React.Dispatch<React.SetStateAction<string[]>>;
  mutation: () => Promise<void>;
}

export const executeOptimisticFavoriteMutation = async ({
  recipeId,
  nextFavorites,
  previousFavorites,
  setCachedFavorites,
  setFavoritePendingIds,
  mutation,
}: ExecuteOptimisticFavoriteMutationOptions): Promise<void> => {
  setRecipePendingState(recipeId, true, setFavoritePendingIds);
  setCachedFavorites(nextFavorites);

  try {
    await mutation();
  } catch (error) {
    rollbackFavoriteMutation(previousFavorites, setCachedFavorites);
    throw error;
  } finally {
    setRecipePendingState(recipeId, false, setFavoritePendingIds);
  }
};

export default executeOptimisticFavoriteMutation;
